import { createSelector } from 'reselect';
import { getMaximumRateLimitOption, getMaximumRateLimitPerMinute } from 'EmailEditorUI/StaggerSends/selectors/StaggerSendsSelectors';
import { getHasEmailThrottleSendSpeedAccess } from 'EmailEditorUI/StaggerSends/selectors/AuthSelectors';
import { STAGGER_EMAIL_SEND_SPEED } from 'EmailEditorUI/StaggerSends/constants';
export const getSendSpeedSaveData = createSelector([getHasEmailThrottleSendSpeedAccess, getMaximumRateLimitOption, getMaximumRateLimitPerMinute], (hasEmailThrottleSendSpeedAccess, maximumRateLimitOption, maximumRateLimitPerMinute) => {
  if (hasEmailThrottleSendSpeedAccess && maximumRateLimitOption === STAGGER_EMAIL_SEND_SPEED.THROTTLE) {
    return {
      maximum_rate_limit_per_minute: maximumRateLimitPerMinute
    };
  }
  return {
    maximum_rate_limit_per_minute: null
  };
});